<template>
  <div class="p-5 rounded-xl shadow-md">
    <h3 class="text-2xl leading-[24px] text-dark mb-5 font-bold">
      {{ title }}
    </h3>
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string;
}
defineProps<Props>();
</script>

<style scoped></style>
